var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 24 24"}},[_c('g',{staticClass:"shadow_spread",attrs:{"stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M18,6 L6,18"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6,6 L18,18"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a99f1f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/IconClose.vue
// module id = null
// module chunks = 